module.exports = __webpack_public_path__ + "img/c1c77c3.jpg";